import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { ENABLE_REDUX_DEVTOOLS } from "stores/constants";

export interface State {
  selectedProjectActionId: number | undefined;
  setSelectedProjectActionId: (id: number) => void;
}

export const useProjectsStore = create<State>()(
  devtools(
    set => ({
      selectedProjectActionId: undefined,
      setSelectedProjectActionId: id =>
        set(
          { selectedProjectActionId: id },
          false,
          "PROJECTS_STORE/setSelectedProjectActionId"
        )
    }),
    { enabled: ENABLE_REDUX_DEVTOOLS, store: "ProjectsStore" }
  )
);
